/*
* Custom JS
* Add custom javascript here!
*/

document.addEventListener('DOMContentLoaded', event => {
});

/** EVENTS
 * Product Form
 * document.addEventListener('product:form:loaded', (event) => {
 *   let variant = event.detail.variant; // Give you the default selected variant
 *   let formElement = event.target;
 *   console.log(variant, formElement)
 * });
 *
 *
 */

(function () {
  function fixAvatarImageSizer() {
    if (
      !window.Shopify ||
      !Shopify.theme ||
      !Shopify.theme.ThemeImages
    ) {
      setTimeout(fixAvatarImageSizer, 50);
      return;
    }

    Shopify.theme.ThemeImages.getSizedImageUrl = function (src, size) {
      if (!src) return null;

      if (typeof src === 'object') {
        src = src.url || src.src || '';
      }

      if (!src) return null;

      // Shopify poate returna URL-uri protocol-relative
      src = String(src);

      // Dacă nu avem nevoie de resize, folosim direct imaginea
      if (!size || size === 'master') {
        return src.replace(/^https?:/, '');
      }

      // Format nou Shopify CDN:
      // păstrăm URL-ul original, care este deja valid
      return src.replace(/^https?:/, '');
    };
  }

  fixAvatarImageSizer();
})();
